import React, { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
//primereact
import { Button } from "primereact/button";
//components
import Select from "../../../../components/input/Select";
import CalendarInput from "../../../../components/input/CalendarInput";
import MultipleSelect from "../../../../components/input/MultipleSelect";
//services
import { postReportSped } from "../../../../services/Report/postReportSped";
//hooks
import { useOptionsSelect } from "../../../../hooks/useOptionsSelect";

const ModalAddSped = ({
  onClose,
  onSuccess,
  ownersOptions,
  parcelOptions,
  loadingOwners,
  loadingParcelDescriptions,
}) => {
  const form = useForm();
  const [loading, setLoading] = useState(false);
  const { accountantsOptions, loadingAccountants } = useOptionsSelect();

  const onSubmit = async (data) => {
    console.log("Data submitted:", data);
    setLoading(true);
    let toastId;
    try {
      toastId = toast.loading("Gerando relatório SPED...");
      const dataSped = new Date(data.date_sped);
      const [month, year] = [dataSped.getMonth() + 1, dataSped.getFullYear()];
      const payload = {
        owner_id: data.owner_id,
        accountant_id: data.accountant_id,
        year: year.toString(),
        month: month,
        installment_description_id: data.parcel_description_id,
      };
      const response = await postReportSped(payload);
      toast.update(toastId, {
        render: "SPED gerado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      if (onSuccess) onSuccess(response.data);
      if (onClose) onClose();
    } catch (error) {
      if (toastId) {
        if (
          error.response &&
          error.response.data.error
        ) {
          if (error.response.data.error === "Contador sem endereço cadastrado."){
            form.setError("accountant_id", {
              type: "manual",
              message: "Contador sem endereço cadastrado.",
            });
          }
          toast.update(toastId, {
            render: error.response.data.error,
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
        } else {
          toast.update(toastId, {
            render: "Erro ao gerar relatório.",
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
        }
      } else {
        toast.error("Erro ao gerar relatório.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <div className="row d-flex mt-4">
        <div className="col-md-6 mb-3">
          <Select
            name="owner_id"
            label="Proprietário *"
            control={form.control}
            errors={form.formState.errors}
            options={ownersOptions}
            isRequired
            optionLabel="label"
            optionValue="value"
            placeholder={
              loadingOwners ? "Carregando..." : "Selecione a proprietário"
            }
          />
        </div>
        <div className="col-md-6 mb-3">
          <Select
            name="accountant_id"
            label={loadingAccountants ? "Carregando..." : "Contador *"}
            control={form.control}
            errors={form.formState.errors}
            options={accountantsOptions}
            isRequired
            optionLabel="label"
            optionValue="value"
            placeholder={
              loadingAccountants ? "Carregando..." : "Selecione o contador"
            }
          />
        </div>
        <div className="col-md-6 mb-3">
          <CalendarInput
            name="date_sped"
            control={form.control}
            label="Data (Mês/Ano) *"
            errors={form.formState.errors}
            isRequired
            view="month"
            mask="mm/yy"
            dateFormat="mm/yy"
            placeholder="MM/YY"
            disabled={loading}
          />
        </div>
        <div className="col-md-6 mb-3">
          <MultipleSelect
            name="parcel_description_id"
            label="Tipo de Parcela*"
            control={form.control}
            rules={{ required: "Campo obrigatório" }}
            options={parcelOptions}
            placeholder={
              loadingParcelDescriptions
                ? "Carregando..."
                : "Selecione as parcelas"
            }
            require
            selectAllLabel="Todas"
          />
        </div>
        <div className="col-12 d-flex justify-content-end mt-2">
          <Button
            type="submit"
            icon="pi pi-check"
            label="Gerar "
            className="p-button-primary"
            style={{
              width: 100,
              height: 48,
              borderRadius: 24,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            loading={loading}
          />
        </div>
      </div>
    </form>
  );
};

export default ModalAddSped;
